import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "@/data/business";
import { SERVICES } from "@/data/services";

export const Footer = () => {
  return (
    <footer className="bg-plush-surface border-t border-plush-gold/10 text-plush-text/90 pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-5 text-sm leading-relaxed text-plush-textMuted max-w-xs">
              A plush velvet sanctuary in Malakpet for deep tissue, Thai,
              full body & aromatherapy massage rituals.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-plush-gold mb-4">
              Services
            </p>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={s.path}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-plush-textMuted hover:text-plush-gold transition-colors"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-plush-gold mb-4">
              Visit Us
            </p>
            <a
              href={BUSINESS.mapsDirectionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address-link"
              className="flex items-start gap-2.5 text-sm text-plush-textMuted hover:text-plush-gold transition-colors leading-relaxed"
            >
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-plush-crimson" />
              {BUSINESS.address}
            </a>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-plush-gold mb-4">
              Call to Book
            </p>
            <a
              href={`tel:${BUSINESS.phoneClean}`}
              data-testid="footer-phone-link"
              className="flex items-center gap-2.5 font-heading text-lg text-plush-text hover:text-plush-gold transition-colors"
            >
              <Phone className="w-4 h-4 text-plush-crimson" />
              {BUSINESS.phoneDisplay}
            </a>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="inline-block mt-4 text-sm text-plush-textMuted hover:text-plush-gold underline underline-offset-4"
            >
              Get Directions →
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-plush-gold/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-plush-textMuted/70">
          <p>© {new Date().getFullYear()} Plush Spa. All rights reserved.</p>
          <p>Malakpet, Hyderabad, Telangana 500036</p>
        </div>
      </div>
    </footer>
  );
};
